import { render, staticRenderFns } from "./GradeView.vue?vue&type=template&id=9a7debc2&scoped=true"
import script from "./GradeView.vue?vue&type=script&lang=js"
export * from "./GradeView.vue?vue&type=script&lang=js"
import style0 from "./GradeView.vue?vue&type=style&index=0&id=9a7debc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7debc2",
  null
  
)

export default component.exports